export default __webpack_public_path__ + "static/media/(61).03f919e5.jpg";